module.exports = __webpack_public_path__ + "static/media/ionic.ac7e1d64.svg";